import { render, staticRenderFns } from "./ProductionTable.vue?vue&type=template&id=2996b15a&"
import script from "./ProductionTable.vue?vue&type=script&lang=js&"
export * from "./ProductionTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports